(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ts-quantity-calculator"] && !Shopify.designMode) return;
  try {
    function tsCalculate(panel){
  const number=(selector)=>Number(panel.querySelector(selector)?.value);
  const area=number('[data-area]'),rate=number('[data-rate]'),pack=number('[data-pack]'),factor=number('[data-unit]');
  const output=panel.querySelector('output');
  if(![area,rate,pack,factor].every(n=>Number.isFinite(n)&&n>0)){output.textContent=panel.dataset.start;return;}
  const required=area*rate*factor, count=required/pack;
  const maximum=Number(panel.dataset.maxRate);
  if(maximum>0&&rate*factor>maximum/10000+1e-12){output.textContent=panel.dataset.limit;return;}
  if(!Number.isFinite(count)||!Number.isFinite(required)){output.textContent=panel.dataset.start;return;}
  const format=n=>n.toLocaleString('en-GB',{maximumSignificantDigits:6});
  let message=panel.dataset.required+' '+format(required)+(panel.dataset.kind==='liquid'?' L':' kg')+'\n'+panel.dataset.packs+' '+Math.ceil(count-Number.EPSILON*Math.max(1,count));
  const water=number('[data-water-rate]');
  if(panel.dataset.kind==='liquid'&&water>0&&Number.isFinite(water)){message+='\n'+panel.dataset.water+' '+format(area*water/10000)+' L';}
  const lines=message.split('\n').map((line,index)=>{const node=document.createElement(index===1?'strong':'span');node.textContent=line;if(index===1)node.className='ts-result-quantity';return node;});
  output.replaceChildren(...lines);
}
document.addEventListener('input',event=>{const panel=event.target.closest('.ts-quantity-calculator');if(panel)tsCalculate(panel);});
document.addEventListener('change',event=>{const panel=event.target.closest('.ts-quantity-calculator');if(panel)tsCalculate(panel);});
document.addEventListener('toggle',event=>{
  const panel=event.target;
  if(!panel.matches?.('.ts-quantity-calculator')||!panel.open||panel.dataset.initialised)return;
  panel.dataset.initialised='true';
  const pattern=panel.dataset.kind==='liquid'?/(\d+(?:\.\d+)?)\s*(?:litres?|liters?|ltr|l)\b/i:/(\d+(?:\.\d+)?)\s*kg\b/i;
  const match=panel.dataset.variant.match(pattern)||panel.dataset.title.match(pattern);
  if(match)panel.querySelector('[data-pack]').value=match[1];
  if(!match&&panel.dataset.kind==='solid'){
    const grams=panel.dataset.variant.match(/(\d+(?:\.\d+)?)\s*g\b/i)||panel.dataset.title.match(/(\d+(?:\.\d+)?)\s*g\b/i);
    if(grams)panel.querySelector('[data-pack]').value=Number(grams[1])/1000;
  }
},true);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ts-turf-calculator"] && !Shopify.designMode) return;
  try {
    (() => {
  const areaFrom = (shape, values) => {
    const keys = {rectangle:['length','width'],triangle:['base','height'],circle:['radius'],area:['area']}[shape];
    if (!keys || !keys.every(key=>Number.isFinite(values[key]) && values[key]>0)) return null;
    const area = shape==='rectangle' ? values.length*values.width : shape==='triangle' ? values.base*values.height/2 : shape==='circle' ? Math.PI*values.radius*values.radius : values.area;
    return Number.isFinite(area) && area>0 ? area : null;
  };
  const orderFor = (area, coverage, waste) => {
    if (!Number.isFinite(area) || area<=0 || !Number.isFinite(coverage) || coverage<=0) return null;
    const needed=area*(waste?1.05:1), ratio=needed/coverage, quantity=Math.ceil(ratio-Number.EPSILON*Math.max(1,ratio));
    return Number.isFinite(needed) && Number.isSafeInteger(quantity) && quantity>0 ? {needed,quantity,covered:quantity*coverage} : null;
  };
  const coverageFor = (title, variant) => {
    const pattern=/(\d+(?:\.\d+)?)\s*(?:m2|m²|sq\s*m)\b/i;
    const match=variant.match(pattern);
    if(match)return Number(match[1]);
    if(/bulk buy/i.test(title) && /^\d+(?:\.\d+)?$/.test(variant.trim()))return Number(variant);
    if(variant==='Default Title')return Number(title.match(pattern)?.[1])||null;
    return null;
  };
  class TurfCalculator extends HTMLElement {
    connectedCallback(){
      if(this.initialised)return;
      this.initialised=true;
      this.data=JSON.parse(this.querySelector('[data-turf-data]').textContent);
      this.form=this.querySelector('form');this.output=this.querySelector('output');
      this.container=this.closest('[id^="ProductInfo-"]');
      this.sync();
      this.form.addEventListener('submit',event=>{event.preventDefault();this.calculate();});
      this.form.addEventListener('input',()=>{this.shapes();this.calculate();});
      this.form.addEventListener('change',()=>{this.shapes();this.calculate();});
      this.onVariant=event=>{if(event.target.name==='id'){this.sync();this.calculate();}};
      this.container?.addEventListener('change',this.onVariant);
    }
    disconnectedCallback(){this.container?.removeEventListener('change',this.onVariant);this.initialised=false;}
    sync(){
      if(!this.data.variants.length)return;
      const id=Number(this.container?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value)||this.data.selected;
      if(id===this.variantId)return;
      this.variantId=id;
      const variant=this.data.variants.find(v=>v.id===id);
      this.form.elements.coverage.value=variant ? coverageFor(this.data.title,variant.title)||'' : '';
    }
    shapes(){const shape=this.form.elements.shape.value;this.querySelectorAll('[data-shape]').forEach(node=>{node.hidden=node.dataset.shape!==shape;node.querySelectorAll('input').forEach(input=>input.disabled=node.hidden);});}
    calculate(){
      const values={};['length','width','base','height','radius','area'].forEach(key=>values[key]=Number(this.form.elements.namedItem(key).value));
      const area=areaFrom(this.form.elements.shape.value,values), result=orderFor(area,Number(this.form.elements.coverage.value),this.form.elements.waste.checked);
      if(!result){this.output.textContent=this.dataset.invalid;return;}
      const format=value=>value.toLocaleString('en-GB',{maximumFractionDigits:2});
      const areaLine=document.createElement('span');areaLine.textContent=this.dataset.areaLabel+' '+format(result.needed)+' m²';
      const quantityLine=document.createElement('strong');quantityLine.className='ts-turf-result-quantity';quantityLine.textContent=this.dataset.quantityLabel+' '+result.quantity;
      const coverageLine=document.createElement('span');coverageLine.textContent=this.dataset.coveredLabel+' '+format(result.covered)+' m²';
      this.output.replaceChildren(areaLine,quantityLine,coverageLine);
    }
  }
  if(!customElements.get('ts-turf-calculator'))customElements.define('ts-turf-calculator',TurfCalculator);
})();
  } catch(e) { console.error(e); }
})();

})();
